import { customerBaseApi } from "@/react/services/api";
import {
  buildFilterQuery,
  buildQueryURL,
} from "@/react/features/support-tools/audit-trail/queryBuilder";

export const auditApi = customerBaseApi.injectEndpoints({
  endpoints: (build) => ({
    getServices: build.query({
      query: () => {
        const searchParams = buildQueryURL({
          page: 0,
          size: 100,
        });
        return {
          url: `audit/services?${searchParams}`,
          method: "GET",
        };
      },
      transformResponse: (response) =>
        response?._embedded?.auditServiceItemVOList,
    }),
    getAudits: build.query({
      query: ({ startDate, endDate, service, page, pageSize }) => {
        const searchParams = buildQueryURL({
          auditService: service,
          page,
          size: pageSize,
          filter: buildFilterQuery([
            { option: "auditTimestamp", operator: ">=", value: startDate },
            { option: "auditTimestamp", operator: "<=", value: endDate },
          ]),
          sort: "auditTimestamp,desc",
        });
        return {
          url: `audit?${searchParams}`,
          method: "GET",
        };
      },
      transformResponse: (response) => ({
        audits: response?._embedded?.auditItemVOList,
        page: response?.page,
      }),
    }),
  }),
});

export const { useGetServicesQuery, useLazyGetAuditsQuery } = auditApi;
